export default defineNuxtRouteMiddleware(async (_to, _from) => {
  /* FIXME: Temporarily disabled until we have specified how to use RudderStack and which data to send.
  if (!import.meta.client) {
    return
  }

  if (to.path !== from.path) {
    const rudderstackEvents = useRudderstackEvents(to)

    setTimeout(() => {
      void rudderstackEvents.rsSendPageEventUser()
      void rudderstackEvents.rsSendPageEventRoyalty()
    }, 500)
  }
   */
})
